import { createComponent } from "@front/utils/alpine";
import $ from "jquery";

function headerScroll() {
    const footerHeight = $('#footer').height() as number;
    const footerOffset = $('#footer').offset()?.top as number;
    var positionComparateurTopInPage = $('#header').offset()?.top as number;
    var positionComparateurBottomInPage = footerOffset - footerHeight;

    $(window).on('scroll', () => {
        if ($(window).scrollTop() as number >= positionComparateurTopInPage && $(window).scrollTop() as number < positionComparateurBottomInPage && $('#cdpcp-table-wrapper').attr('data-count') == "cdpcp_5_compare") {
            $('.scroll-left, .scroll-right').show();
        } else {
            $('.scroll-left, .scroll-right').hide();
        }
    });
}

export default createComponent(() => ({
    setup () {
        $('.menu-rolex .menu-mobile .material-icons').addClass('i-[arrow] -rotate-90 h-4 w-4');
        $('.slider-rolex .slider-right .material-icons').addClass('i-[arrow] -rotate-90 h-6 w-6');
        $('.slider-rolex .slider-left .material-icons').addClass('i-[arrow] rotate-90 h-6 w-6');

        $('.slider-rolex .slider-right').on('click', function () {
            var width = $('.slider.first').width() as number;
            var size = width + 30;

            $(".sliders").animate({ marginLeft: '-' + size + 'px' }, 750);
            $('.slider-rolex .slider-right .material-icons').css('color', '#127749');
            $('.slider-rolex .slider-left .material-icons').css('color', '#ccc');
        });

        $('.slider-rolex .slider-left').on('click', function () {
            $(".sliders").animate({ marginLeft: '0' }, 750);
            $('.slider-rolex .slider-right .material-icons').css('color', '#ccc');
            $('.slider-rolex .slider-left .material-icons').css('color', '#127749');
        });

        $('body').on('click', '.cdpcp-table__cell-inner.crit', function () {
            $('.cdpcp-table__feature-row').css('display', 'table-row');
            $('.cdpcp-table__feature-row.more').css('display', 'none');
            headerScroll();
        });

        $('body').on('click', '.cdpcp-table__cell-inner.crit_less', function () {
            $('.cdpcp-table__feature-row').css('display', 'none');
            $('.cdpcp-table__feature-row.more').css('display', 'table-row');
            headerScroll();
        });

        $('body').on('click', '.menu-mobile .click-menu', function () {
            $(this).siblings('.menu').toggle();
        });
    },
}));
